import React, { Component, Fragment } from 'react';
import { Button, Col, Form, Row, Card } from 'antd';
import { BaseForm } from './Base';
import { BuyForm } from './BuyForm';
import { SellForm } from './SellForm';
import { IndicatorManager } from '../../Shared/IndicatorManager';
import { StopLossForm } from './StopLossForm';
import { ADCAForm } from './ADCAForm';

const nestedKeys = [
    'sell',
    'buy',
    'stoploss',
    'rt_sell',
    'adca',
    'rt_buy',
    'rt_final_sell',
    'dca_buy',
    'dca_sell'
];

class StrategyFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let data = {};
                Object.keys(values).forEach(key => {
                    let copied = false;
                    nestedKeys.forEach(whitelisted => {
                        if (key.indexOf(whitelisted) === 0) {
                            data[whitelisted] = data[whitelisted] || {};
                            data[whitelisted][key.replace(`${whitelisted}_`, '')] = values[key];
                            copied = true;
                        }
                    });
                    if (!copied && values[key] != null) {
                        data[key] = values[key];
                    }
                });

                this.props.onSubmit(data);
            }
        });
    }

    render() {
        return (
            <Form>
                <Row gutter={24}>
                    <Col row={24}>
                        <BaseForm
                            initialData={this.props.data}
                            edit={this.props.edit}
                            title={this.props.title}
                            form={this.props.form}
                        />

                        {this.renderByType(this.props.form.getFieldValue('type'))}

                        <div style={{ textAlign: 'right' }}>
                            <Button
                                onClick={this.handleSubmit.bind(this)}
                                type="primary"
                                size="large"
                            >
                                Save
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        );
    }

    renderByType(type) {
        const meta = this.props.data ? this.props.data.meta : {};
        const sellTAEnabled = this.props.form.getFieldValue('sell_ta_enabled');
        switch (type) {
            case 'buy_sell':
                return (
                    <Fragment>
                        <Card title="Buying" style={{ marginBottom: 15 }} bordered={false}>
                            <BuyForm mode={'buy'} form={this.props.form} />

                            <IndicatorManager
                                enabled
                                form={this.props.form}
                                mode={'buy'}
                                meta={meta}
                            />
                        </Card>

                        <Card title="Selling" style={{ marginBottom: 15 }} bordered={false}>
                            <SellForm form={this.props.form} mode={'sell'} />

                            <IndicatorManager
                                enabled={sellTAEnabled}
                                form={this.props.form}
                                mode={'sell'}
                                meta={meta}
                            />
                        </Card>

                        <StopLossForm form={this.props.form} />
                    </Fragment>
                );

            case 'signal':
                return (
                    <Fragment>
                        <Card title="Buying" style={{ marginBottom: 15 }} bordered={false}>
                            <BuyForm mode={'buy'} form={this.props.form} />
                        </Card>

                        <Card title="Selling" style={{ marginBottom: 15 }} bordered={false}>
                            <SellForm form={this.props.form} mode={'sell'} />

                            <IndicatorManager
                                enabled={sellTAEnabled}
                                form={this.props.form}
                                mode={'sell'}
                                meta={meta}
                            />
                        </Card>

                        <StopLossForm form={this.props.form} />
                    </Fragment>
                );
            case 'art':
                let sellARTTAEnabled = this.props.form.getFieldValue('rt_final_sell_ta_enabled');

                return (
                    <Fragment>
                        <Card title="Reverse Sell" style={{ marginBottom: 15 }} bordered={false}>
                            <IndicatorManager
                                enabled={true}
                                form={this.props.form}
                                mode={'rt_sell'}
                                art
                                meta={meta}
                            />
                        </Card>

                        <Card title="Reverse Buy" style={{ marginBottom: 15 }} bordered={false}>
                            <BuyForm mode={'rt_buy'} form={this.props.form} />

                            <IndicatorManager
                                enabled
                                form={this.props.form}
                                mode={'rt_buy'}
                                meta={meta}
                            />
                        </Card>

                        <Card
                            title="Final Sell"
                            id="base"
                            style={{ marginBottom: 15 }}
                            bordered={false}
                        >
                            <SellForm form={this.props.form} mode={'rt_final_sell'} />

                            <IndicatorManager
                                enabled={sellARTTAEnabled}
                                form={this.props.form}
                                mode={'rt_final_sell'}
                                meta={meta}
                            />
                        </Card>

                        <StopLossForm form={this.props.form} />
                    </Fragment>
                );

            case 'trigger':
                return (
                    <Fragment>
                        <Card title="Buy Signal" style={{ marginBottom: 15 }} bordered={false}>
                            <IndicatorManager
                                enabled
                                form={this.props.form}
                                mode={'buy'}
                                meta={meta}
                            />
                        </Card>

                        <Card title="Sell Signal" style={{ marginBottom: 15 }} bordered={false}>
                            <IndicatorManager
                                enabled
                                form={this.props.form}
                                mode={'sell'}
                                meta={meta}
                            />
                        </Card>
                    </Fragment>
                );

            case 'adca':
                let sellADCATAEnabled = this.props.form.getFieldValue('dca_sell_ta_enabled');
                return (
                    <Fragment>
                        <ADCAForm form={this.props.form} />

                        <Card title="Buying" style={{ marginBottom: 15 }} bordered={false}>
                            <BuyForm mode={'dca_buy'} form={this.props.form} />

                            <IndicatorManager
                                enabled
                                form={this.props.form}
                                mode={'dca_buy'}
                                meta={meta}
                            />
                        </Card>

                        <Card title="Selling" style={{ marginBottom: 15 }} bordered={false}>
                            <SellForm mode={'dca_sell'} form={this.props.form} />
                            <IndicatorManager
                                enabled={sellADCATAEnabled}
                                form={this.props.form}
                                mode={'dca_sell'}
                                meta={meta}
                            />
                        </Card>

                        <StopLossForm form={this.props.form} />
                    </Fragment>
                );
            default: //noop
        }
    }
}

const mapProps = (prefix, data, acc) => {
    if (!data) return;

    Object.keys(data).forEach(key => {
        if (prefix === 'adca') {
            acc[`${prefix}_levels`] = Form.createFormField({ value: data['levels'] });

            if (Array.isArray(data[key])) {
                data[key].forEach((v, i) => {
                    acc[`${prefix}_${key}[${i}]`] = Form.createFormField({ value: v });
                });
            }
        }

        acc[`${prefix}_${key}`] = Form.createFormField({ value: data[key] });
    });
};

export const StrategyForm = Form.create({
    mapPropsToFields: props => {
        const data = {};

        Object.keys(props.data || {}).forEach(key => {
            let copied = false;
            nestedKeys.forEach(whitelisted => {
                if (key.indexOf(whitelisted) === 0 && key.indexOf('indicators') === -1) {
                    mapProps(whitelisted, props.data[whitelisted], data);
                    copied = true;
                    return;
                }
            });

            if (!copied) data[key] = Form.createFormField({ value: props.data[key] });
        });
        return data;
    }
})(StrategyFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Shared/Form.js